import axios from 'axios';
// 创建Axios实例
const baseApi = import.meta.env.VITE_APP_BASE_API;
console.log(baseApi)
const axiosInstance = axios.create({
  baseURL: baseApi, // 你的API基础URL
  timeout: 10000, // 请求超时时间（毫秒）
  headers: {
    'Content-Type': 'application/json', // 默认请求头
    // 其他需要的请求头可以在这里添加
  },
  
});
console.log(process.env.NODE_ENV)

// 请求拦截器（可选）
axiosInstance.interceptors.request.use(
  (config) => {
    //给请求头设置token
    const token = window.localStorage.getItem('token') || '';
     console.log(token)
    if (token) {
      config.headers.token = token;
    }

    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器（可选）
axiosInstance.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么，比如格式化数据
    return response;
  },
  (error) => {
    // 对响应错误做点什么，比如全局错误处理
    return Promise.reject(error);
  }
);

export default axiosInstance;
